module.exports = __webpack_public_path__ + "static/media/feature-organizer.a38ff913.png";